import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
// import Accordion from "react-bootstrap/Accordion";
import { fetchAllGymwisePTStatsData } from "../../redux/reducers/apiSlice";
import PaymentLinkTable from "../payment-link-system/PaymentLinkTable";
import GymWiseStatsMobile from "./mobile-view/GymWiseStatsMobile";
import ReactVortoxSpinner from "../common-components/ReactVortoxSpinner";
import TableSkeleton from "../common-components/TableSkeleton";

const GymWiseStats = ({ userInfoData, prevFilters }) => {
  const dispatch = useDispatch();

  const { gymwisePtStatsLoading, gymwisePtStats } = useSelector(
    (state) => state.api
  );

  const iniFilters = {
    page: 1,
    limit: 50,
    start_date: prevFilters.selectedStartDate
      ? prevFilters.selectedStartDate
      : "",
    end_date: prevFilters.selectedEndDate ? prevFilters.selectedEndDate : "",
  };
  const [filters, setFilters] = useState(iniFilters);
  const [allGymStatsData, setAllGymStatsData] = useState([]);

  function getGymwiseStats(filters) {
    dispatch(
      fetchAllGymwisePTStatsData({
        filters: filters,
        token: userInfoData?.token,
      })
    );
  }

  useEffect(() => {
    setFilters((prevs) => ({
      ...prevs,
      start_date: prevFilters.selectedStartDate
        ? prevFilters.selectedStartDate
        : "",
      end_date: prevFilters.selectedEndDate ? prevFilters.selectedEndDate : "",
    }));
  }, [prevFilters.selectedStartDate, prevFilters.selectedEndDate]);

  useEffect(() => {
    getGymwiseStats(filters);
  }, [filters]);

  useEffect(() => {
    if (
      gymwisePtStats?.status &&
      gymwisePtStats?.data?.length > 0 &&
      !gymwisePtStatsLoading
    ) {
      setAllGymStatsData(gymwisePtStats.data);
    } else {
      setAllGymStatsData([]);
    }
  }, [gymwisePtStats, gymwisePtStatsLoading]);

  const tbColumns = [
    {
      dataField: "gym_name",
      text: "Gym Name",
      formatter: (_, row) => {
        return (
          <span className="tb-data minWidth150" style={{ textAlign: "start" }}>
            {row?.gym_name || "NA"}
          </span>
        );
      },
    },
    {
      dataField: "total",
      text: "Total Subscription",
      formatter: (_, row) => {
        return (
          <span
            className={`tb-data ${
              row?.gym_name === "Total" ? "withPadding borderRdius8" : ""
            } `}
            style={{
              background: row?.gym_name === "Total" ? "#65B741" : "",
              color: row?.gym_name === "Total" ? "#fff" : "",
            }}
          >
            {row?.total || 0}
          </span>
        );
      },
    },
    {
      dataField: "total_handover_pending",
      text: "Handover Pending",
      formatter: (_, row) => {
        return (
          <span
            className={`tb-data ${
              row?.gym_name === "Total" ? "withPadding borderRdius8" : ""
            } `}
            style={{
              background: row?.gym_name === "Total" ? "#65B741" : "",
              color: row?.gym_name === "Total" ? "#fff" : "",
            }}
          >
            {row?.total_handover_pending || 0}
          </span>
        );
      },
    },
    {
      dataField: "total_handover_completed",
      text: "Handover Completed",
      formatter: (_, row) => {
        return (
          <span
            className={`tb-data ${
              row?.gym_name === "Total" ? "withPadding borderRdius8" : ""
            } `}
            style={{
              background: row?.gym_name === "Total" ? "#65B741" : "",
              color: row?.gym_name === "Total" ? "#fff" : "",
            }}
          >
            {row?.total_handover_completed || 0}
          </span>
        );
      },
    },
    {
      dataField: "total_pending",
      text: "PT Consultation Pending",
      formatter: (_, row) => {
        return (
          <span
            className={`tb-data ${
              row?.gym_name === "Total" ? "withPadding borderRdius8" : ""
            } `}
            style={{
              background: row?.gym_name === "Total" ? "#65B741" : "",
              color: row?.gym_name === "Total" ? "#fff" : "",
            }}
          >
            {row?.total_pending || 0}
          </span>
        );
      },
    },
    {
      dataField: "total_completed",
      text: "PT Consultation Completed",
      formatter: (_, row) => {
        return (
          <span
            className={`tb-data ${
              row?.gym_name === "Total" ? "withPadding borderRdius8" : ""
            } `}
            style={{
              background: row?.gym_name === "Total" ? "#65B741" : "",
              color: row?.gym_name === "Total" ? "#fff" : "",
            }}
          >
            {row?.total_completed || 0}
          </span>
        );
      },
    },
    {
      dataField: "trial_done_cnvrtd",
      text: "PT Consultation Done And Converted",
      formatter: (_, row) => {
        return (
          <span
            className={`tb-data ${
              row?.gym_name === "Total" ? "withPadding borderRdius8" : ""
            } `}
            style={{
              background: row?.gym_name === "Total" ? "#65B741" : "",
              color: row?.gym_name === "Total" ? "#fff" : "",
            }}
          >
            {row?.trial_done_cnvrtd || 0}
          </span>
        );
      },
    },
    {
      dataField: "trial_notdone_cnvrtd",
      text: "PT Consultation Not Done And Converted",
      formatter: (_, row) => {
        return (
          <span
            className={`tb-data ${
              row?.gym_name === "Total" ? "withPadding borderRdius8" : ""
            } `}
            style={{
              background: row?.gym_name === "Total" ? "#65B741" : "",
              color: row?.gym_name === "Total" ? "#fff" : "",
            }}
          >
            {row?.trial_notdone_cnvrtd || 0}
          </span>
        );
      },
    },
    {
      dataField: "closed_cnvrtd_prspct",
      text: "Closed And Converted",
      formatter: (_, row) => {
        return (
          <span
            className={`tb-data ${
              row?.gym_name === "Total" ? "withPadding borderRdius8" : ""
            } `}
            style={{
              background: row?.gym_name === "Total" ? "#65B741" : "",
              color: row?.gym_name === "Total" ? "#fff" : "",
            }}
          >
            {row?.closed_cnvrtd_prspct || 0}
          </span>
        );
      },
    },
    {
      dataField: "closed_not_cnvrtd_prspct",
      text: "Closed And Not Converted",
      formatter: (_, row) => {
        return (
          <span
            className={`tb-data ${
              row?.gym_name === "Total" ? "withPadding borderRdius8" : ""
            } `}
            style={{
              background: row?.gym_name === "Total" ? "#65B741" : "",
              color: row?.gym_name === "Total" ? "#fff" : "",
            }}
          >
            {row?.closed_not_cnvrtd_prspct || 0}
          </span>
        );
      },
    },
  ];

  if (gymwisePtStatsLoading) {
    return <TableSkeleton columns={9} rows={5} isFirstColSticky={true} />;
  }

  return (
    <>
      <div className="fullWidthFlexCenter overflowAuto separatedTable no-border-table mt15 hideMobile">
        <PaymentLinkTable
          tableData={allGymStatsData}
          tableColumns={tbColumns}
          isFirstColSticky={true}
        />
      </div>

      <div className="lead-logs-card-container pt-trial-tb-cards only-mobile">
        <GymWiseStatsMobile allGymStatsData={allGymStatsData} />
      </div>
      {/* <div className="pt-track-stats-data mt30 mb30">
        <Accordion>
          <Accordion.Item eventKey="0">
            <Accordion.Header>PT Track Reports</Accordion.Header>

            <Accordion.Body>
              <div className="fullWidthFlexCenter overflowAuto separatedTable no-border-table mt15 hideMobile">
                <PaymentLinkTable
                  tableData={allGymStatsData}
                  tableColumns={tbColumns}
                  isFirstColSticky={true}
                />
              </div>

              <div className="lead-logs-card-container pt-trial-tb-cards only-mobile">
                <GymWiseStatsMobile allGymStatsData={allGymStatsData} />
              </div>
            </Accordion.Body>
          </Accordion.Item>
        </Accordion>
      </div> */}
    </>
  );
};

export default GymWiseStats;
